import { DrawerBase } from 'bog-arcade-core-ui/core/DrawerBase';

import { translationKeys } from '../../core/translation/translation';
import {
  BALANCE_VALUE,
  BONUS_COST_AMOUNT,
  LAST_WIN_VALUE,
} from '../../stateManagment';
import { FONT_LATO_NAME } from '../../core/constats';
import { getAmount } from '../../core/helpers/getAmount';

export class BalanceLastWinDrawer extends DrawerBase {
  getContent({
    sizes: { w = 205, h = 80 } = {},
    position: { x = 0, y = 0 } = {},
    isBonus = false,
    fontSize = 20,
  } = {}) {
    const rect = this.createGraphics()
      .drawRect(
        x,
        y,
        w,
        h,
      );

    const titleStyle = {
      fontFamily: FONT_LATO_NAME,
      fontSize: fontSize,
      fill: 0xe3c632,
      fontWeight: 900,
    };

    const valueStyle = {
      fontFamily: FONT_LATO_NAME,
      fontSize: fontSize,
      fill: 0xFFFFFF,
      fontWeight: 900,
    };

    const balanceContainer = this.createContainer('balanceContainer');
    const lastWinContainer = this.createContainer('lastWinContainer');
    const amountCostContainer = this.createContainer('amountCostContainer');

    const balanceTitle = new this.PIXI.Text(`${translationKeys.balance}: `, titleStyle);
    const lastWinTitle = new this.PIXI.Text(`${translationKeys.lastWin}: `, titleStyle);
    const amountTitle = new this.PIXI.Text(`${translationKeys.betAmount}: `, titleStyle);

    const balanceValue = new this.PIXI.Text('', valueStyle);
    const lastWinValue = new this.PIXI.Text('', valueStyle);
    const amountValue = new this.PIXI.Text('', valueStyle);

    this.setPosition(balanceTitle, { x: 15, y: 10 });
    this.setPosition(lastWinTitle, { x: 15, y: 40 });
    this.setPosition(amountTitle, { x: 15, y: 40 });
    this.setPosition(balanceValue, { x: 15 + balanceTitle.width, y: 10 });
    this.setPosition(lastWinValue, { x: 15 + lastWinTitle.width, y: 40 });
    this.setPosition(amountValue, { x: 15 + amountTitle.width, y: 40 });

    this.addSubscriber(BALANCE_VALUE.subscribe((value) => {
      balanceValue.text = getAmount(value);
    }, true));
    this.addSubscriber(LAST_WIN_VALUE.subscribe((value) => {
      lastWinValue.text = getAmount(value);
    }, true));
    this.addSubscriber(BONUS_COST_AMOUNT.subscribe((value) => {
      amountValue.text = getAmount(value);
    }, true));

    balanceContainer.addChild(
      balanceTitle,
      balanceValue,
    );

    lastWinContainer.addChild(
      lastWinTitle,
      lastWinValue,
    );

    amountCostContainer.addChild(
      amountTitle,
      amountValue,
    );

    if (isBonus) {
      amountCostContainer.visible = true;
      lastWinContainer.visible = false;
    } else {
      amountCostContainer.visible = false;
      lastWinContainer.visible = true;
    }

    rect.addChild(
      balanceContainer,
      lastWinContainer,
      amountCostContainer,
    );
    return rect;
  }
}

export const balanceLastWinDrawer = new BalanceLastWinDrawer();
